export const RouteNamesEnum = {
    login: "Login",
    home: "Home",
    viewMeeting: "ViewMeeting",
    viewMeetingPublic: "ViewMeetingPublic",
    viewMeetingPublicRecording: "ViewMeetingPublicRecording",
    viewSession: "ViewSession",
    sessionEdit: "SessionEdit",
    sessionCreate: "SessionCreate",
    participants: "Participants",
    participantsImport: "ParticipantsImport",
    meetingsSchedule: "MeetingsSchedule",
    appointment: "Appointment",
    partner: "Partner",
    webConferencesRecording: "webConferencesRecording",

    /**
     * @TICKETS
     */
    ticketSystemIdeas: "ticketSystemIdeas",
    ticketSystemIdeaView: "ticketSystemIdeaView",
    ticketSystemIdeaEdit: "ticketSystemIdeaEdit",
    ticketSystemIdeaCreate: "ticketSystemIdeaCreate",

    ticketSystemProblems: "ticketSystemProblems",
    ticketSystemProblemView: "ticketSystemProblemView",
    ticketSystemProblemEdit: "ticketSystemProblemEdit",
    ticketSystemProblemCreate: "ticketSystemProblemCreate",

    ticketSystemDashboard: "ticketSystemDashboard",
    committeesList: "committeesList",
    committeesCreate: "committeesCreate",
    committeesEdit: "committeesEdit",
    committeesView: "committeesView",
    empty: ""
} as const;

export type RouteNamesEnum = typeof RouteNamesEnum[keyof typeof RouteNamesEnum];
